// extracted by mini-css-extract-plugin
module.exports = {"main":"Default_main__337U9","tint":"Default_tint__2wrI6","error":"Default_error__2Yt61","error2":"Default_error2__2tRzM","error3":"Default_error3__3HXns"};